import {root} from 'effector-root'

export const request = root.createEvent()
